<template>
  <div class="home">
    <index />
  </div>
</template>

<script>
import Index from '@/components/index.vue'

export default {
  name: 'home',
  components: {
    Index
  }
}
</script>
